import React from 'react';
import { Calendario } from 'components/articles';
import './index.css';

function Encuentros() {

  return (
    <div className="wrapper encuentros">
      <article>
        <Calendario variant={null} />
      </article>
    </div>
  );
}

export default Encuentros;
